var _path, _path2, _rect, _path3, _g, _g2, _rect2, _path4, _path5, _g3, _circle, _path6, _g4, _path7, _circle2, _path8, _path9, _rect3, _g5, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDoodles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 460",
    width: 280,
    height: 460,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22 L32 46 H4 Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 20 L168 28 L177 28 L170 33 L172 42 L165 37 L158 42 L160 33 L153 28 L162 28 Z",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 24,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "white",
    strokeWidth: 1.2,
    transform: "rotate(14 243.5 31.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 80 L62 94 M62 80 L48 94",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 72)",
    stroke: "white",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12 A10 10 0 0 1 26 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 135)",
    stroke: "white",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9 H18 V21 C18 24 16 25.5 11 25.5 C6 25.5 4 24 4 21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.5 H21.5 C23.2 11.5 24.2 12.6 24.2 14.2 C24.2 15.8 23.2 16.9 21.5 16.9 H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5 C7.5 2.2 8.4 2.2 8.4 3.5 M12 3.5 C12 2.2 12.9 2.2 12.9 3.5"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 145,
    width: 14,
    height: 14,
    stroke: "white",
    strokeWidth: 1.15,
    transform: "rotate(-12 112 152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235 140 L249 154 M249 140 L235 154",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 200 L73 208 L82 208 L75 213 L77 222 L70 217 L63 222 L65 213 L58 208 L67 208 Z",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(215 195)",
    stroke: "white",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12 A10 10 0 0 1 26 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 270,
    r: 8,
    stroke: "white",
    strokeWidth: 1.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100 265 L114 279 M114 265 L100 279",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 255)",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9 H18 V21 C18 24 16 25.5 11 25.5 C6 25.5 4 24 4 21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.5 H21.5 C23.2 11.5 24.2 12.6 24.2 14.2 C24.2 15.8 23.2 16.9 21.5 16.9 H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5 C7.5 2.2 8.4 2.2 8.4 3.5 M12 3.5 C12 2.2 12.9 2.2 12.9 3.5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55 320 L71 346 H39 Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 335,
    r: 9,
    stroke: "white",
    strokeWidth: 1.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240 320 L254 334 M254 320 L240 334",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 390 L36 404 M36 390 L22 404",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 395,
    width: 13,
    height: 13,
    stroke: "white",
    strokeWidth: 1.1,
    transform: "rotate(-8 101.5 401.5)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 385)",
    stroke: "white",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12 A10 10 0 0 1 26 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 6,
    height: 9,
    rx: 2
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M230 388 L246 414 H214 Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDoodles);
export default __webpack_public_path__ + "static/media/sidebar-doodles.6b33e0d775eae49728f8173f0193d548.svg";
export { ForwardRef as ReactComponent };